/* PulseBands — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var cfg = window.PulseBands || {};
  var routes = cfg.routes || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function announce(message) {
    var region = $('[data-live-region]');
    if (region) { region.textContent = ''; window.setTimeout(function () { region.textContent = message; }, 60); }
  }

  /* ---------------------------------------------------------------- Drawers */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var openDrawer = null;
  var lastFocused = null;

  function drawerOpen(drawer) {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.classList.add('drawer-open');
    openDrawer = drawer;
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    var focusTarget = drawer.querySelector('[data-drawer-initial-focus]') || drawer.querySelector(FOCUSABLE);
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 60);
  }

  function drawerClose(drawer) {
    drawer = drawer || openDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    if (openDrawer === drawer) openDrawer = null;
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('aria-controls'));
      if (target) { event.preventDefault(); drawerOpen(target); }
      return;
    }
    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      drawerClose(event.target.closest('.nav-drawer, .cart-drawer'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!openDrawer) return;
    if (event.key === 'Escape') { drawerClose(); return; }
    if (event.key !== 'Tab') return;
    var items = $$(FOCUSABLE, openDrawer).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* ----------------------------------------------------------- Sticky header */
  var header = $('[data-header]');
  if (header) {
    var lastY = window.scrollY;
    var ticking = false;
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 4);
      if (!openDrawer) {
        if (y > lastY && y > 240) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  }

  /* -------------------------------------------------------------- Accordions */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.accordion__trigger');
    if (!trigger) return;
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.classList.toggle('is-open', !isOpen);
  });

  /* --------------------------------------------------------- Announcement bar */
  var announcementBar = $('[data-announcement]');
  if (announcementBar) {
    var slides = $$('.announcement__slide', announcementBar);
    var interval = parseInt(announcementBar.getAttribute('data-interval'), 10) || 5000;
    if (slides.length > 1 && !reduceMotion) {
      var index = 0;
      window.setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, interval);
    }
  }

  /* ------------------------------------------------------------ Scroll reveal */
  if (document.body.classList.contains('animations-enabled') && 'IntersectionObserver' in window && !reduceMotion) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('[data-reveal]').forEach(function (el) { observer.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  }

  /* --------------------------------------------------------- Sticky mobile CTA */
  var stickyCta = $('[data-sticky-cta]');
  if (stickyCta && 'IntersectionObserver' in window) {
    var sentinel = $('[data-sticky-cta-trigger]');
    if (sentinel) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyCta.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(sentinel);
    }
  }

  /* ---------------------------------------------------------------- Cart AJAX */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  /* The Section Rendering API keys responses by SECTION ID, which for a JSON
     template is the template's section key — not the file name. Both templates
     print their own id into the DOM so we always ask for the right one. */
  function drawerSectionId() {
    var drawer = $('#CartDrawer');
    return drawer ? drawer.getAttribute('data-cart-drawer-id') : null;
  }

  function cartPageSectionId() {
    var main = $('[data-cart-main]');
    return main ? main.getAttribute('data-cart-main') : null;
  }

  function replaceInner(sectionsHtml, id, selector) {
    var markup = sectionsHtml && id && sectionsHtml[id];
    if (!markup) return false;
    var fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector(selector);
    var current = $(selector);
    if (!fresh || !current) return false;
    current.innerHTML = fresh.innerHTML;
    return true;
  }

  function refreshCartDrawer(sectionsHtml) {
    if (!$('#CartDrawer')) return;
    replaceInner(sectionsHtml, drawerSectionId(), '[data-cart-drawer-contents]');
  }

  function refreshCartPage(sectionsHtml) {
    if (!$('[data-cart-main]')) return;
    if (!replaceInner(sectionsHtml, cartPageSectionId(), '[data-cart-main]')) {
      window.location.reload();
    }
  }

  function sectionsToRequest() {
    return [drawerSectionId(), cartPageSectionId()].filter(Boolean).join(',');
  }

  function postCart(url, body) {
    body.sections = sectionsToRequest();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function applyCartResponse(data) {
    if (typeof data.item_count === 'number') updateCartCount(data.item_count);
    refreshCartDrawer(data.sections);
    refreshCartPage(data.sections);
  }

  /* Quick add / add to cart */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = '…'; }

    var formData = new FormData(form);
    var body = { items: [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) }] };

    postCart(routes.cart_add_url + '.js', body)
      .then(function (data) {
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          data.item_count = cart.item_count;
          return data;
        });
      })
      .then(function (data) {
        applyCartResponse(data);
        announce(cfg.strings.added);
        if (button) { button.textContent = cfg.strings.added; }
        if (cfg.cartType === 'drawer' && $('#CartDrawer')) drawerOpen($('#CartDrawer'));
      })
      .catch(function (error) {
        announce(error.message);
        window.console && console.warn('[PulseBands]', error.message);
      })
      .finally(function () {
        window.setTimeout(function () {
          if (button) { button.removeAttribute('aria-disabled'); button.textContent = original; }
        }, 1200);
      });
  });

  /* Quantity + remove inside cart */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(parseInt(input.dataset.min || '0', 10), next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.getAttribute('data-line'), 0, remove.closest('.cart-drawer, [data-cart-main]'));
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line'), parseInt(input.value, 10), input.closest('.cart-drawer, [data-cart-main]'));
  });

  function changeLine(line, quantity, scope) {
    if (!line) return;
    if (scope) scope.classList.add('is-loading');
    postCart(routes.cart_change_url + '.js', { line: line, quantity: quantity })
      .then(applyCartResponse)
      .catch(function (error) { window.console && console.warn('[PulseBands]', error.message); })
      .finally(function () { if (scope) scope.classList.remove('is-loading'); });
  }

  /* ------------------------------------------------------- Product variants */
  /* Shopify CDN images take their size from a `width` query parameter, so a
     srcset can be rebuilt from any single URL rather than shipped per variant. */
  function cdnSrcset(url, widths) {
    return widths.map(function (w) {
      var sized = url.replace(/([?&])width=\d+/, '$1width=' + w);
      if (sized === url) sized += (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      return sized + ' ' + w + 'w';
    }).join(', ');
  }

  function swapGalleryImage(variant) {
    if (!variant || !variant.image) return;
    var tile = $('[data-gallery-main]');
    var img = tile && tile.querySelector('img');
    if (!img) return;
    if (img.getAttribute('src') === variant.image) return;

    /* Fade through the change so a colour swap does not read as a glitch. */
    var apply = function () {
      img.setAttribute('src', variant.image);
      img.setAttribute('srcset', cdnSrcset(variant.image, [400, 600, 800, 1000, 1400]));
      if (variant.image_alt) img.setAttribute('alt', variant.image_alt);
      img.removeAttribute('width');
      img.removeAttribute('height');
    };

    if (reduceMotion) { apply(); return; }
    tile.classList.add('is-swapping');
    apply();
    if (img.decode) {
      img.decode().catch(function () {}).then(function () { tile.classList.remove('is-swapping'); });
    } else {
      window.setTimeout(function () { tile.classList.remove('is-swapping'); }, 200);
    }
  }

  $$('[data-variant-picker]').forEach(function (picker) {
    var form = document.getElementById(picker.getAttribute('data-form'));
    var dataEl = document.getElementById(picker.getAttribute('data-variants'));
    if (!form || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    picker.addEventListener('change', function () {
      var chosen = $$('input:checked', picker).map(function (input) { return input.value; });
      var match = variants.find(function (variant) {
        return variant.options.every(function (option, i) { return option === chosen[i]; });
      });

      $$('[data-option-selected]', picker).forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-selected'), 10);
        if (chosen[idx]) el.textContent = chosen[idx];
      });

      var idInput = form.querySelector('[name="id"]');
      var button = form.querySelector('[type="submit"]');
      var priceEl = $('[data-product-price]');

      if (!match) {
        if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = cfg.strings.soldOut; }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (button) {
        button.removeAttribute('aria-disabled');
        button.textContent = match.available ? cfg.strings.addToCart : cfg.strings.soldOut;
        if (!match.available) button.setAttribute('aria-disabled', 'true');
      }
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      swapGalleryImage(match);

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* ------------------------------------------------------------------ Video */
  /* Every video in the theme is rendered by snippets/video-media.liquid with NO src.
     The source is assigned here from matchMedia, so exactly one file is downloaded —
     never both the desktop and the mobile cut — and reduced-motion visitors download
     none at all and keep the poster image. Playback starts when the video scrolls
     into view and pauses when it leaves, so a page of videos costs one video. */
  var mqMobileVideo = window.matchMedia('(max-width: 749px)');

  function videoSource(video) {
    var mobile = video.getAttribute('data-src-mobile');
    var desktop = video.getAttribute('data-src-desktop');
    return mqMobileVideo.matches ? mobile || desktop : desktop || mobile;
  }

  function videoActivate(video) {
    var src = videoSource(video);
    if (!src || video.currentSrc === src || video.getAttribute('src') === src) return;
    video.setAttribute('src', src);
  }

  function videoPlay(video) {
    if (reduceMotion) return;
    if (video.getAttribute('data-autoplay') !== 'true') return;
    videoActivate(video);
    var attempt = video.play();
    /* Autoplay can be refused (data saver, iOS low power). The poster stays put,
       which is exactly the fallback we want — so swallow it rather than warn. */
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  function videoPause(video) {
    if (!video.paused) video.pause();
  }

  var videos = $$('[data-pb-video]');
  if (videos.length) {
    videos.forEach(function (video) {
      video.addEventListener('playing', function () {
        var wrap = video.closest('[data-video-media]');
        if (wrap) wrap.classList.add('is-playing');
      });
    });

    if (!reduceMotion && 'IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) videoPlay(entry.target);
          else videoPause(entry.target);
        });
      }, { threshold: 0.25 });

      videos.forEach(function (video) {
        if (video.getAttribute('data-eager') === 'true') videoPlay(video);
        videoObserver.observe(video);
      });
    } else if (!reduceMotion) {
      videos.forEach(function (video) {
        if (video.getAttribute('data-eager') === 'true') videoPlay(video);
      });
    }

    /* Rotating a phone, or dragging a desktop window narrow, changes which cut is
       correct. Re-point any video that is already playing; leave the rest alone so
       nothing downloads off screen. */
    var onVideoBreakpoint = function () {
      videos.forEach(function (video) {
        if (video.paused) {
          video.removeAttribute('src');
          return;
        }
        videoActivate(video);
        videoPlay(video);
      });
    };
    if (mqMobileVideo.addEventListener) mqMobileVideo.addEventListener('change', onVideoBreakpoint);
    else if (mqMobileVideo.addListener) mqMobileVideo.addListener(onVideoBreakpoint);
  }

  /* -------------------------------------------------------------- Carousels */
  /* Scrolling itself is native (scroll-snap + overflow-x), so swipe, trackpad,
     keyboard and screen readers already work with JS off. This only adds the
     desktop arrows and hides them when there is nothing to scroll. */
  $$('[data-carousel]').forEach(function (carousel) {
    var track = $('[data-carousel-track]', carousel);
    if (!track) return;

    var scope = carousel.closest('section') || carousel.parentElement || document;
    var nav = $('[data-carousel-nav]', scope);
    var prev = nav && $('[data-carousel-prev]', nav);
    var next = nav && $('[data-carousel-next]', nav);

    function step() {
      var slide = track.firstElementChild;
      if (!slide) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function scrollable() {
      return track.scrollWidth - track.clientWidth > 4;
    }

    function sync() {
      if (!nav) return;
      if (!scrollable()) {
        nav.setAttribute('hidden', '');
        return;
      }
      nav.removeAttribute('hidden');
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    var scrollTick = false;
    track.addEventListener('scroll', function () {
      if (scrollTick) return;
      scrollTick = true;
      window.requestAnimationFrame(function () { sync(); scrollTick = false; });
    }, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    else window.addEventListener('resize', sync);

    sync();
  });

  /* ------------------------------------------------- Shipping date estimates */
  /* Dates are rendered server-side by snippets/shipping-timeline.liquid so they are
     right with JS off and before this runs. This recalculates them from the
     VISITOR'S clock, which also corrects a page served from cache.

     Native Date only — setDate() rolls months and years over for us, so there is no
     reason to ship a date library for this. */
  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  function addBusinessDays(date, days, excludeWeekends) {
    var result = new Date(date.getTime());
    var added = 0;
    var target = Math.max(0, days | 0);
    while (added < target) {
      result.setDate(result.getDate() + 1);
      if (!excludeWeekends) { added++; continue; }
      var day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  function formatShipDate(date) {
    return MONTHS[date.getMonth()] + ' ' + date.getDate();
  }

  function formatShipRange(start, end) {
    var a = formatShipDate(start);
    var b = formatShipDate(end);
    return a === b ? a : a + ' – ' + b;
  }

  /* Current wall-clock time in the merchant's timezone, without a tz library. */
  function nowInZone(timeZone) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date());
      var got = {};
      parts.forEach(function (part) { got[part.type] = part.value; });
      return new Date(+got.year, +got.month - 1, +got.day, +got.hour % 24, +got.minute, +got.second);
    } catch (error) {
      return new Date();
    }
  }

  $$('[data-shipping-timeline]').forEach(function (root) {
    var procMin = parseInt(root.getAttribute('data-processing-min'), 10);
    var procMax = parseInt(root.getAttribute('data-processing-max'), 10);
    var transitMin = parseInt(root.getAttribute('data-transit-min'), 10);
    var transitMax = parseInt(root.getAttribute('data-transit-max'), 10);
    if (isNaN(procMin) || isNaN(procMax) || isNaN(transitMin) || isNaN(transitMax)) return;

    /* A merchant can type a minimum larger than its maximum. Sort rather than
       render a backwards range. */
    if (procMin > procMax) { var p = procMin; procMin = procMax; procMax = p; }
    if (transitMin > transitMax) { var t = transitMin; transitMin = transitMax; transitMax = t; }

    var excludeWeekends = root.getAttribute('data-exclude-weekends') !== 'false';
    var countdown = root.getAttribute('data-countdown') === 'true';

    var noteEl = $('[data-ship-note]', root);
    var orderedEl = $('[data-ship-ordered]', root);
    var shippedEl = $('[data-ship-shipped]', root);
    var deliveredEls = $$('[data-ship-delivered], [data-ship-delivery]', root);

    function render() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      /* Baseline is the day processing starts. It only moves when a cutoff is
         configured AND today's cutoff has already passed — never as a trick to
         restart a timer. */
      var baseline = today;
      var pastCutoff = false;
      var remainingMs = 0;

      if (countdown) {
        var zone = root.getAttribute('data-timezone') || 'America/Los_Angeles';
        var shopNow = nowInZone(zone);
        var cutoff = new Date(shopNow.getTime());
        cutoff.setHours(
          parseInt(root.getAttribute('data-cutoff-hour'), 10) || 0,
          parseInt(root.getAttribute('data-cutoff-minute'), 10) || 0,
          0, 0
        );
        if (shopNow.getTime() < cutoff.getTime()) {
          remainingMs = cutoff.getTime() - shopNow.getTime();
        } else {
          pastCutoff = true;
          baseline = addBusinessDays(today, 1, excludeWeekends);
        }
      }

      var shipStart = addBusinessDays(baseline, procMin, excludeWeekends);
      var shipEnd = addBusinessDays(baseline, procMax, excludeWeekends);
      var deliverStart = addBusinessDays(baseline, procMin + transitMin, excludeWeekends);
      var deliverEnd = addBusinessDays(baseline, procMax + transitMax, excludeWeekends);

      if (orderedEl) orderedEl.textContent = formatShipDate(today);
      if (shippedEl) shippedEl.textContent = formatShipRange(shipStart, shipEnd);
      deliveredEls.forEach(function (el) { el.textContent = formatShipRange(deliverStart, deliverEnd); });

      if (noteEl && countdown) {
        if (pastCutoff) {
          noteEl.textContent = root.getAttribute('data-after-cutoff-message') || 'Processing starts the next business day';
        } else {
          var minutes = Math.max(1, Math.ceil(remainingMs / 60000));
          var hours = Math.floor(minutes / 60);
          var label = hours > 0 ? hours + 'h ' + (minutes % 60) + 'm' : minutes + 'm';
          var template = root.getAttribute('data-countdown-message') || 'Order within {time} to ship today';
          noteEl.textContent = template.replace('{time}', label);
        }
      }
    }

    render();
    if (countdown) window.setInterval(render, 30000);
  });

  /* ------------------------------------------------------------ Sort/filters */
  $$('[data-auto-submit]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) form.submit();
    });
  });
})();
